export const AutoHideEmailEvent = "autoHideEmail";
